<template>
     <v-container fluid>
    <div class="tables-basic">
        <br>
      <h1 v-if="verNuevo==0"  class="page-title mt-16 mb-6">Mantenimientos</h1>
      <v-row>
        <v-col cols="12">
          <v-card class="employee-list mb-1">
            <v-card-title class="pa-6 pb-3">
                <v-btn @click="mostrarNuevo()"  v-if="verNuevo==0"  rounded color="primary" small dark>Nuevo Mantenimiento</v-btn>
              <v-spacer></v-spacer>
              
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                clearable
                single-line
                hide-details
                 v-if="verNuevo==0"
              ></v-text-field>
              
            </v-card-title>
                 <v-data-table
            
              dense
              :headers="headersMantenimientos"
              :items="mantenimientos"
              :search="search"
               v-if="verNuevo==0"
              >
              
            <template v-slot:[`item.actions`]="{item}">
                <v-icon @click="generarPdf(item)" small class="mr-2" >mdi-download</v-icon>
                <v-icon @click="editItem(item)" small class="mr-2" >mdi-border-color</v-icon>
            </template>
        
            </v-data-table>
          
           
                 <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
                                        <span class="headline">{{ formTitle }}</span>
                                        

        <v-layout row wrap>       

            <v-flex xs11 sm11 lg11 x11>
              
              <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step
        :complete="e1 > 1"
        step="1"
      >
        Activo
      </v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step
        :complete="e1 > 2"
        step="2"
      >
        Mecanico
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="e1 > 3"
        step="3"
      >
        Electrico
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step 
        :complete="e1 > 4"
      step="4">
       Hidraulico
      </v-stepper-step>
       <v-divider></v-divider>

      <v-divider></v-divider>

      <v-stepper-step 
        :complete="e1 > 5"
      step="5">
       Seguridad
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step 
        :complete="e1 > 6"
      step="6">
       Llantas
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step 
        :complete="e1 > 7"
      step="7">
       Estetico
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step 
        :complete="e1 > 8"
      step="8">
       Estructura
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
       <v-stepper-content step="1">
        <v-card class="mb-12"  height="700px">
          <v-row>
            <v-col cols="12">
               <v-row>
                            <v-col>
                                  <v-text-field v-model="activo2" @keyup.enter="listarActivpoPorNss()"  class="text-xs-center" append-icon="mdi-search" label="Numero de Serie"></v-text-field>
                            </v-col>
                            <v-col>
                                  <v-text-field v-model="numeroEconomicoBusqueda" @keyup.enter="listarActivpoPorNumeroEconomico()"  class="text-xs-center" append-icon="mdi-search" label="Numero Economico"></v-text-field>
                            </v-col>
                            <v-col>
                                  <v-text-field v-model="facturaBusqueda" @keyup.enter="listarActivpoPorFactura()"  class="text-xs-center" append-icon="mdi-search" label="Factura"></v-text-field>
                            </v-col>
                           
                        </v-row>
                          <v-row>
                        
                            
                            <v-col v-if="mostrarDetalleDeActivo">
                                <v-card
                                    elevation="24"
                                    max-width="444"
                                    class="mx-auto"
                                >
                                    <v-system-bar lights-out></v-system-bar>
                                    <v-carousel
                                    :continuous="false"
                                    :cycle="cycle"
                                    :show-arrows="false"
                                    hide-delimiter-background
                                    delimiter-icon="mdi-minus"
                                    height="300"
                                    >
                                   <v-carousel-item
                                            v-for="(item, i) in activoPorQuery.fotos"
                                            :key="i"
                                        >
                                            <v-img :src="item" contain max-height="300"></v-img>
                                        </v-carousel-item>
                                    </v-carousel>
                                    <v-list densetwo-line>
                                    <v-list-item>
                                        <v-list-item-avatar>
                                        <v-img src="https://i.ibb.co/RhFJyQn/trianguloflecha-Mesa-de-trabajo-1.png"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                        <v-list-item-title>{{activoPorQuery.personal.nombreCompleto}}</v-list-item-title>
                                        <v-list-item-subtitle>{{activoPorQuery.personal.empresa.nombreComercial}}</v-list-item-subtitle>

                                        </v-list-item-content>        
                                    </v-list-item>
                                    </v-list>
                                    <v-divider></v-divider>
                                    <v-list dense>
                                        <v-list-item>
                                         <v-list-item-content>
                                            <v-list-item-subtitle>Tipo de Unidad: <strong>{{activoPorQuery.tipoUnidad}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Activo: <strong>{{activoPorQuery.nombreActivo}}</strong></v-list-item-subtitle>                    
                                            <v-list-item-subtitle>Marca: <strong>{{activoPorQuery.marca}}</strong> Modelo: <strong>{{activoPorQuery.modelo}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Numero de Serie: <strong>{{activoPorQuery.numeroSerie}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Estatus: <strong>{{activoPorQuery.estatu}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Factura: <strong>{{activoPorQuery.factura}}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Costo: <strong> ${{activoPorQuery.costo.toLocaleString('en-US')}}</strong></v-list-item-subtitle>

                                         </v-list-item-content>

                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
            </v-col>
            
          </v-row>
        </v-card>

        <v-btn
          color="primary"
          @click="nextStep"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card class="mb-12"  height="950px">
          <v-row>
            <v-col cols="12">
              <v-data-table dense  :items-per-page="19"  :headers="headers" :items="items" hide-default-footer class="elevation-1">
                <template v-slot:[`item.estatus`]="{item}">
                    <v-chip-group
                      v-model="item.estatusM"
                      active-class="deep-purple--text text--accent-4"
                      
                    >
                      <v-chip
                        x-small
                        v-for="size in sizes"
                        :key="size"
                        :value="size"
                       
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                </template>
                   <template v-slot:[`item.descripcion`]="{item}">
                   <p style="font-size:13px" class="font-weight-light">
                      {{item.descripcion}}
                    </p>
                </template>

                   <template v-slot:[`item.observaciones`]="{item}">
                     <v-text-field
                     dense
                        v-model="item.observaciones"
                       
                      ></v-text-field>
                   
                </template>

                 <template v-slot:[`item.requisicion`]="{item}">
                     <v-text-field
                     dense
                      v-model="item.requisicion"
                      
                      ></v-text-field>
                   
                </template>
                 <template v-slot:[`item.fotos`]="{item}">
                   <v-file-input v-if="!item.fotoM"
                    v-model="item.fotoM"
                    hide-input
                    truncate-length="15"
                  ></v-file-input>
                    <v-file-input v-if="item.fotoM" 
                    dense
                      accept="image/png, image/jpeg, image/bmp"
                        hide-input
                          v-model="item.fotoM"
                      prepend-icon="mdi-camera"
                      ></v-file-input>
                </template>
               
              </v-data-table>
            </v-col>
            
          </v-row>
        </v-card>

        <v-btn
          color="primary"
          @click="nextStep"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
     <v-card class="mb-12"  height="550px">
          <v-row>
            <v-col cols="12">
              <v-data-table dense  :items-per-page="19"  :headers="headersElectrico" :items="itemsElectrico" hide-default-footer class="elevation-1">
                <template v-slot:[`item.estatus`]="{item}">
                    <v-chip-group
                      v-model="item.estatusM"
                      active-class="deep-purple--text text--accent-4"
                      
                    >
                      <v-chip
                        x-small
                        v-for="size in sizes"
                        :key="size"
                        :value="size"
                       
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                </template>
                   <template v-slot:[`item.descripcion`]="{item}">
                   <p style="font-size:13px" class="font-weight-light">
                      {{item.descripcion}}
                    </p>
                </template>

                   <template v-slot:[`item.observaciones`]="{item}">
                     <v-text-field
                     dense
                        v-model="item.observaciones"
                       
                      ></v-text-field>
                   
                </template>

                 <template v-slot:[`item.requisicion`]="{item}">
                     <v-text-field
                     dense
                      v-model="item.requisicion"
                      
                      ></v-text-field>
                   
                </template>
                 <template v-slot:[`item.fotos`]="{item}">
                   <v-file-input v-if="!item.fotoM"
                    v-model="item.fotoM"
                    hide-input
                    truncate-length="15"
                  ></v-file-input>
                    <v-file-input v-if="item.fotoM" 
                    dense
                      accept="image/png, image/jpeg, image/bmp"
                        hide-input
                          v-model="item.fotoM"
                      prepend-icon="mdi-camera"
                      ></v-file-input>
                </template>
               
              </v-data-table>
            </v-col>
             
          </v-row>
        </v-card>

        <v-btn
          color="primary"
          @click="nextStep"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="4">
      <v-card class="mb-12"  height="550px">
          <v-row>
            <v-col cols="12">
             
              <v-data-table dense  :items-per-page="19"  :headers="headers" :items="itemsHidraulico" hide-default-footer class="elevation-1">
                <template v-slot:[`item.estatus`]="{item}">
                    <v-chip-group
                      v-model="item.estatusM"
                      active-class="deep-purple--text text--accent-4"
                      
                    >
                      <v-chip
                        x-small
                        v-for="size in sizes"
                        :key="size"
                        :value="size"
                       
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                </template>
                   <template v-slot:[`item.descripcion`]="{item}">
                   <p style="font-size:13px" class="font-weight-light">
                      {{item.descripcion}}
                    </p>
                </template>

                   <template v-slot:[`item.observaciones`]="{item}">
                     <v-text-field
                     dense
                        v-model="item.observaciones"
                       
                      ></v-text-field>
                   
                </template>

                 <template v-slot:[`item.requisicion`]="{item}">
                     <v-text-field
                     dense
                      v-model="item.requisicion"
                      
                      ></v-text-field>
                   
                </template>
                 <template v-slot:[`item.fotos`]="{item}">
                   <v-file-input v-if="!item.fotoM"
                    v-model="item.fotoM"
                    hide-input
                    truncate-length="15"
                  ></v-file-input>
                    <v-file-input v-if="item.fotoM" 
                    dense
                      accept="image/png, image/jpeg, image/bmp"
                        hide-input
                          v-model="item.fotoM"
                      prepend-icon="mdi-camera"
                      ></v-file-input>
                </template>
               
              </v-data-table>
            </v-col>
            
          </v-row>
        </v-card>
          <v-btn
          color="primary"
          @click="nextStep"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>

         <v-stepper-content step="5">
      <v-card class="mb-12"  height="550px">
          <v-row>
            <v-col cols="12">
              <v-data-table dense  :items-per-page="19"  :headers="headers" :items="itemsSeguridad" hide-default-footer class="elevation-1">
                <template v-slot:[`item.estatus`]="{item}">
                    <v-chip-group
                      v-model="item.estatusM"
                      active-class="deep-purple--text text--accent-4"
                      
                    >
                      <v-chip
                        x-small
                        v-for="size in sizes"
                        :key="size"
                        :value="size"
                       
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                </template>
                   <template v-slot:[`item.descripcion`]="{item}">
                   <p style="font-size:13px" class="font-weight-light">
                      {{item.descripcion}}
                    </p>
                </template>

                   <template v-slot:[`item.observaciones`]="{item}">
                     <v-text-field
                     dense
                        v-model="item.observaciones"
                       
                      ></v-text-field>
                   
                </template>

                 <template v-slot:[`item.requisicion`]="{item}">
                     <v-text-field
                     dense
                      v-model="item.requisicion"
                      
                      ></v-text-field>
                   
                </template>
                 <template v-slot:[`item.fotos`]="{item}">
                   <v-file-input v-if="!item.fotoM"
                    v-model="item.fotoM"
                    hide-input
                    truncate-length="15"
                  ></v-file-input>
                    <v-file-input v-if="item.fotoM" 
                    dense
                      accept="image/png, image/jpeg, image/bmp"
                        hide-input
                          v-model="item.fotoM"
                      prepend-icon="mdi-camera"
                      ></v-file-input>
                </template>
               
              </v-data-table>
            </v-col>
          
            
          </v-row>
        </v-card>
          <v-btn
          color="primary"
          @click="nextStep"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>

         <v-stepper-content step="6">
      <v-card class="mb-12"  height="550px">
          <v-row>
            <v-col cols="12">
              <v-data-table dense  :items-per-page="19"  :headers="headers" :items="itemsLlantas" hide-default-footer class="elevation-1">
                <template v-slot:[`item.estatus`]="{item}">
                    <v-chip-group
                      v-model="item.estatusM"
                      active-class="deep-purple--text text--accent-4"
                      
                    >
                      <v-chip
                        x-small
                        v-for="size in sizes"
                        :key="size"
                        :value="size"
                       
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                </template>
                   <template v-slot:[`item.descripcion`]="{item}">
                   <p style="font-size:13px" class="font-weight-light">
                      {{item.descripcion}}
                    </p>
                </template>

                   <template v-slot:[`item.observaciones`]="{item}">
                     <v-text-field
                     dense
                        v-model="item.observaciones"
                       
                      ></v-text-field>
                   
                </template>

                 <template v-slot:[`item.requisicion`]="{item}">
                     <v-text-field
                     dense
                      v-model="item.requisicion"
                      
                      ></v-text-field>
                   
                </template>
                 <template v-slot:[`item.fotos`]="{item}">
                   <v-file-input v-if="!item.fotoM"
                    v-model="item.fotoM"
                    hide-input
                    truncate-length="15"
                  ></v-file-input>
                    <v-file-input v-if="item.fotoM" 
                    dense
                      accept="image/png, image/jpeg, image/bmp"
                        hide-input
                          v-model="item.fotoM"
                      prepend-icon="mdi-camera"
                      ></v-file-input>
                </template>
               
              </v-data-table>
            </v-col>
            
          </v-row>
        </v-card>
          <v-btn
          color="primary"
          @click="nextStep"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>

        <v-stepper-content step="7">
      <v-card class="mb-12"  height="550px">
          <v-row>
            <v-col cols="12">
              <v-data-table dense  :items-per-page="19"  :headers="headers" :items="itemsEstetico" hide-default-footer class="elevation-1">
                <template v-slot:[`item.estatus`]="{item}">
                    <v-chip-group
                      v-model="item.estatusM"
                      active-class="deep-purple--text text--accent-4"
                      
                    >
                      <v-chip
                        x-small
                        v-for="size in sizes"
                        :key="size"
                        :value="size"
                       
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                </template>
                   <template v-slot:[`item.descripcion`]="{item}">
                   <p style="font-size:13px" class="font-weight-light">
                      {{item.descripcion}}
                    </p>
                </template>

                   <template v-slot:[`item.observaciones`]="{item}">
                     <v-text-field
                     dense
                        v-model="item.observaciones"
                       
                      ></v-text-field>
                   
                </template>

                 <template v-slot:[`item.requisicion`]="{item}">
                     <v-text-field
                     dense
                      v-model="item.requisicion"
                      
                      ></v-text-field>
                   
                </template>
                 <template v-slot:[`item.fotos`]="{item}">
                   <v-file-input v-if="!item.fotoM"
                    v-model="item.fotoM"
                    hide-input
                    truncate-length="15"
                  ></v-file-input>
                    <v-file-input v-if="item.fotoM" 
                    dense
                      accept="image/png, image/jpeg, image/bmp"
                        hide-input
                          v-model="item.fotoM"
                      prepend-icon="mdi-camera"
                      ></v-file-input>
                </template>
               
              </v-data-table>
            </v-col>
            
          </v-row>
        </v-card>
          <v-btn
          color="primary"
          @click="nextStep"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>

       <v-stepper-content step="8">
      <v-card class="mb-12"  height="700px">
          <v-row>
            <v-col cols="12">
              <v-data-table dense  :items-per-page="19"  :headers="headers" :items="itemsEstructura" hide-default-footer class="elevation-1">
                <template v-slot:[`item.estatus`]="{item}">
                    <v-chip-group
                      v-model="item.estatusM"
                      active-class="deep-purple--text text--accent-4"
                      
                    >
                      <v-chip
                        x-small
                        v-for="size in sizes"
                        :key="size"
                        :value="size"
                       
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                </template>
                   <template v-slot:[`item.descripcion`]="{item}">
                   <p style="font-size:13px" class="font-weight-light">
                      {{item.descripcion}}
                    </p>
                </template>

                   <template v-slot:[`item.observaciones`]="{item}">
                     <v-text-field
                     dense
                        v-model="item.observaciones"
                       
                      ></v-text-field>
                   
                </template>

                 <template v-slot:[`item.requisicion`]="{item}">
                     <v-text-field
                     dense
                      v-model="item.requisicion"
                      
                      ></v-text-field>
                   
                </template>
                 <template v-slot:[`item.fotos`]="{item}">
                   <v-file-input v-if="!item.fotoM"
                    v-model="item.fotoM"
                    hide-input
                    truncate-length="15"
                  ></v-file-input>
                    <v-file-input v-if="item.fotoM" 
                    dense
                      accept="image/png, image/jpeg, image/bmp"
                        hide-input
                          v-model="item.fotoM"
                      prepend-icon="mdi-camera"
                      ></v-file-input>
                </template>
               
              </v-data-table>
            </v-col>
               <v-col cols="4">
                 <v-switch
              v-model="condiciones"
              label="El equipo se encuentra en condiciones de operar?"
              color="indigo"
              hide-details
            ></v-switch>
              </v-col>
              <v-col cols="8">
           <v-text-field
                     dense
                      v-model="comentarios"
                      
                      ></v-text-field>
            </v-col>
          </v-row>
        
           
        
        </v-card>
          <v-btn
          color="primary"
          @click="guardar"
        >
          Continue
        </v-btn>

        <v-btn text>
          Cancel
        </v-btn>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>

  

  
            </v-flex>    
           
        </v-layout>
    </v-container>
    
          </v-card>
          
        </v-col>
        
      </v-row>
      
    </div>
  
     </v-container>
</template>

<script>
import jsPDF from 'jspdf'
import moment from 'moment'
import S3 from 'aws-s3'
import axios from 'axios'
export default {
   
    data(){
        return{
            headers: [
          
                { text: "Descripción", value: "descripcion" },
                { text: "Estatus", value: "estatus"},
                { text: "Observaciones", value: "observaciones"},
                { text: "Requisición", value: "requisicion"},
                { text: "Fotos", value: "fotos"},
                
            ],
            headersElectrico : [
               { text: "Descripción", value: "descripcion" },
                { text: "Estatus", value: "estatus"},
                { text: "Observaciones", value: "observaciones"},
                { text: "Requisición", value: "requisicion"},
                { text: "Fotos", value: "fotos"},
            ],
            headersMantenimientos :[
               { text : "Actions", value :"actions"},
              { text : "Activo", value :"activo.nombreActivo"},
              { text : "Modelo", value :"activo.modelo"},
            
            ],
            mantenimientos:[],
            singleSelect: false,
            condiciones:false,
            comentarios:'',
            search:'',
            activo2:'',
            numeroEconomicoBusqueda:'',
            facturaBusqueda:'',
            fotoM:'',
            estado:'',
          estatusM:'',
            requisicion:'',
          activoPorQuery:[],
          mostrarDetalleDeActivo:false,
            logoImg:'data:image/png;base64,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',
            fotos:[],
            e1: 1,
            menuFotos:false,
            sizes:['B','M','R','N/a'],
           
            items:[
              { descripcion:'Sistema de frenos (balates, rotores y nivel de liquido de freno',observaciones:'',estatusM:'', requisicion:'' },
              { descripcion:'Sistema, Neumatico (Valvulas de freno, conexiones y mangueras)',observaciones:'',estatusM:'' ,requisicion:'' },
              { descripcion:'Revisión de Niveles',observaciones:'' ,estatusM:'',requisicion:''},
              { descripcion: "Lubricantes en General",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Pernos de giro de tornamesa (Lubricación, Desgaste y Funcionamiento",observaciones:'', estatusM:'',requisicion:''},
              { descripcion: "Fugas de Motor (Diferenciales masas, reductores, malacates)",observaciones:'',estatusM:'',requisicion:''},
              {descripcion: "Banda de Motor y Accesorios (Desgaste",observaciones:'',estatusM:'',requisicion:''},
              {descripcion: "Sistema de Dirección",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Desgaste de poleas y cables de Malacate",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Radiadores/Enfriadores",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Deposito de Anticongelante",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Ventiladores",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Matracas",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Chambers",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Clutch",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Bolsas de Aire",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Amortiguadores",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Alineación (Estado de Terminales de dirección",observaciones:'',estatusM:'',requisicion:''},
              { descripcion: "Gavilanes",observaciones:'',estatusM:'',requisicion:''},

            ],
            itemsElectrico:[
              { descripcion:'Luces (transito, direccionales, cuartos, stop, reversa, luces de trabajo, cabina de operación',observaciones:''},
              { descripcion:'Arranque (marcha, solenoide, switch, alternador',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Torreta',observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Cableado general",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Sistema de control (modulos)",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Alarma de reversa",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Caja de fusibles",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Interruptores generales",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Limpia vidrios",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Baterias",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Indicadores",observaciones:'',estatusM:'', requisicion:''},
            ],
             itemsHidraulico  :[
              { descripcion:'Mangeras en general (Deterioro, Fugas)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Bombas Hidraulicas',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Cilindro Hidraulicos (Fugas y Daños)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Bancos de valvulas",observaciones:'',estatusM:'', requisicion:''},
            ],
             itemsSeguridad:[
              { descripcion:'Calcas de seguridad',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Torreta',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Sistema LMI (A2B, display, cableado) ',observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Gancho principal y auxiliar (seguros y resortes)",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Matachispas",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Vidrios/Espejos",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Cerraduras",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Escaleras",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Tolvas sueltas (tornilleria)",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Cable principal y auxiliar (Lubricacion, remates, socket, chavetas)",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Platos estabilizador (seguros, resortes y grietas",observaciones:'',estatusM:'', requisicion:''},
            ],
            itemsLlantas:[
              { descripcion:'Condicion (Desgaste)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Tuercas de Rueda (Apriete)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Calibración de Aire',observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Rines",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Birlos",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Valvulas",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Baleros",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Retenes",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Llanta de refacción",observaciones:'',estatusM:'', requisicion:''},
          
            ],
              itemsEstetico:[
              { descripcion:'Pintura (Corrosión y Golpes)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Silla (Desgaste y Funcionamiento)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Tolvas y Molduras interior y exterior de cabina',observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Economicos, Logos",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Limpieza en general",observaciones:'',estatusM:'', requisicion:''},         
            ],
              itemsEstructura:[
              { descripcion:'Chasis (fisuras)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Barras estabilizadoras (fisuradas)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion:'Pluma y secciones de pluma (fisuradas)',observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Ganzo bastidor (fisuras)",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Pernos",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Tornamesa de giro",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Quinta",observaciones:'',estatusM:'', requisicion:''},
              {descripcion: "Patines",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Madera",observaciones:'',estatusM:'', requisicion:''},
               {descripcion: "Perno rey",observaciones:'',estatusM:'', requisicion:''},
              { descripcion: "Espejo",observaciones:'',estatusM:'', requisicion:''},
          
            ],

            
          cycle: true,
            verNuevo:0,
             editedIndex: -1,
             e6: 1,
            nombreComercial:'',
            tiposDeUnidad:['Autos y Pick Ups','Motocicletas','Tractocamion','Plataforma','Grúa Terrestre','Montacargas','Cargador Frontal'],
            estatus:['N/D','Operativo','Fuera de Servicio','No Localizado'],
            submited:'',
            alert:'',
            options: {
            locale: "en-US",
            prefix: "$",
            suffix: "",
            length: 11,

            company_logo:{
                w: 110,
                h: 35
            },

            precision: 2
            },
   
    
        }
    },
    watch:{
        
    },
    computed: {
        config() {
            return {
                bucketName: "cicsagruas.net",
                dirName: "fotos" /* optional */,
                region: "us-west-1",
                accessKeyId: "AKIA5DNSJBDUIMGT267Y",
                secretAccessKey: "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",
                s3Url: this.baseUrl
            };
        },
       
         configDoc() {
            return {
                bucketName: "cicsagruas.net",
                dirName: "documentos" /* optional */,
                region: "us-west-1",
                accessKeyId: "AKIA5DNSJBDUIMGT267Y",
                secretAccessKey: "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",
                s3Url: this.baseUrl
            };
        },
    baseUrl() {
      return "https://s3.us-west-1.amazonaws.com/cicsagruas.net";
    },
    S3Client() {
      return new S3(this.config);
    },
    S3ClientDoc() {
      return new S3(this.configDoc);
    },
    newFileName() {
      return Math.random()
        .toString()
        .slice(2);
    },
     

    url() {
      return `${this.baseUrl}/${'fotos'}/`;
    },
     urlDoc() {
      return `${this.baseUrl}/${'documentos'}/`;
    },

    dateRangeText() {
      return this.dates.join(" al ");
    },
        formTitle() {
        return this.editedIndex === -1 ? "Nuevo Mantenimiento" : "Editar Mantenimiento";
        }
    },
    created(){
       this.listar()
    },
    methods:{

          generarPdf(item){
            var doc = new jsPDF("p", "pt","a4");
            var startX=45;
            var startY=53;
       //Encabezado
          
            doc.setFontSize(7.5)
            doc.setFont(undefined, 'bold')
            doc.addImage('https://i.ibb.co/CsjSkJ5/Logotipo-CICSA.png','JPEG',startX,startY+=5,75,45);
            doc.rect(42, 50, 80, 60,)
            doc.rect(122, 50, 240, 25,)
            doc.text('CORPORATIVO INDUSTRIAL Y COMERCIAL S.A. DE C.V.',154,65);
            doc.rect(122, 75, 240, 35,)
            doc.setFontSize(8)
            doc.text('CHECK LIST MANTENIMIENTO',190,95);
            doc.rect(362, 50, 110, 60,)
            doc.rect(472, 50, 80, 25,)
            doc.rect(472, 75, 80, 35,)
            doc.addImage('https://i.ibb.co/FDwv0Gc/dnv-removebg-preview.png','JPEG',375,53,93,58);
            doc.text('FOLIO NO:',492,65);
            doc.text(item.folio_mantenimiento.toString(),510,95);
           
           doc.rect(42, 110, 80, 20,)
           doc.text('No. Economico:',46,125);
           doc.rect(42, 130, 80, 20,)
           doc.text('Modelo:',46,145);
           doc.rect(42, 150, 80, 20,)
           doc.text('Numero de Serie:',46,165);
          doc.setFont(undefined, 'normal')
           doc.rect(122, 110, 140, 40,)
           doc.text(item.activo.numeroEconomico,'156',125);
           doc.rect(122, 130, 140, 40,)
           doc.text(item.activo.modelo,156,145);
           //doc.rect(152, 150, 110, 40,)
           doc.text(item.activo.numeroSerie,156,165);
           doc.rect(262, 110, 60, 60,)
 let fecha = moment(item.fechaDeCaputa).format('LL');
           doc.text(fecha,356,145);
           doc.rect(322, 110, 230, 20,)
           doc.rect(322, 130, 230, 20,)
           doc.rect(322, 150, 230, 20,)
           doc.setFont(undefined, 'bold')
           doc.text('Fecha:',326,145);
          
           doc.text('Horometro / KM:',326,165);

           doc.rect(42, 170, 80, 20,)
           doc.text('SISTEMA',65,182);
           doc.rect(122, 170, 140, 20,)
           doc.text('DESCRIPCION',165,182);
           doc.rect(262, 170, 60, 10,)
           
           doc.rect(262, 180, 15, 10,)
           doc.text('B',267,188);
           doc.rect(277, 180, 15, 10,)
           doc.text('M',281,188);
           doc.rect(292, 180, 15, 10,)
           doc.text('R',296,188);
           doc.rect(307, 180, 15, 10,)
            doc.text('N/a',308,188);
          
           doc.text('ESTATUS',272,178);
           doc.rect(322, 170, 150, 20,)
           doc.text('OBSERVACIONES',365,182);
           doc.rect(472, 170, 80, 20,)
           doc.text('REQUISICIÓN',485,182);
            //Información de activos

            var lMargin=63; //left margin in mm
          var rMargin=182; //right margin in mm
          var pdfInMM=380;  // width of A4 in mm
          var pageCenter=pdfInMM/2;

           var lMarginO=63; //left margin in mm
          var rMarginO=182; //right margin in mm
          var pdfInMMO=785;  // width of A4 in mm
          var pageCenterO=pdfInMMO/2;

           
     doc.setFontSize(7.5)
    doc.setFont(undefined, 'normal')
		
      doc.rect(472, 170, 80, 20,)

      let z = 198;
      let y = 190
      for(let i=0;i<item.mecanico.length;i++){

           doc.rect(262, y , 15, 26,)
           doc.rect(277, y , 15, 26,)
           doc.rect(292, y , 15, 26,)
           doc.rect(307, y , 15, 26,)
            
          doc.text( doc.splitTextToSize(item.mecanico[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z,'center')
          doc.rect(122, y , 140, 26,)
          doc.text( doc.splitTextToSize(item.mecanico[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z,'center')
          doc.rect(322, y , 150, 26,)
          doc.text(item.mecanico[i].requisicion,480,198)
          doc.rect(472, y , 80, 26,)
          item.mecanico[i].estatusM=='B' ? doc.text('X',267,y+15,)  : doc.text('',267,y+15,)  
          item.mecanico[i].estatusM=='M' ? doc.text('X',282,y+15,) : doc.text('',267,y+15,) 
          item.mecanico[i].estatusM=='R' ? doc.text('X',297,y+15,) : doc.text('',267,y+15,) 
          item.mecanico[i].estatusM=='N/a' ?  doc.text('X',297,y+15,)  : doc.text('',267,y+15,) 
          z+=26
          y+=26
      }
        let z2 = 692 ;
        let y2 = 684

       for(let i=0;i<5;i++){

           doc.rect(262,  y2 , 15, 26,)
           doc.rect(277, y2 , 15, 26,)
           doc.rect(292, y2 , 15, 26,)
           doc.rect(307, y2 , 15, 26,)
         
          doc.text( doc.splitTextToSize(item.electrico[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z2,'center')
          doc.rect(122, y2 , 140, 26,)
          doc.text( doc.splitTextToSize(item.electrico[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z2,'center')
          doc.rect(322, y2 , 150, 26,)
          doc.text(item.electrico[i].requisicion,480,z2)
          doc.rect(472, y2 , 80, 26,)
          item.electrico[i].estatusM=='B' ?  doc.text('X',267,y2+15,) : doc.text('',267,y2+15,) 
          item.electrico[i].estatusM=='M' ?  doc.text('X',282,y2+15,) : doc.text('',267,y2+15,) 
          item.electrico[i].estatusM=='R' ?  doc.text('X',297,y2+15,) : doc.text('',267,y2+15,) 
          item.electrico[i].estatusM=='N/a' ?  doc.text('X',297,y2+15,) : doc.text('',267,y2+15,) 
          z2+=26
          y2+=26
      } 

      doc.rect(42,190,80,494,)
      doc.setFontSize(8)
      doc.setFont(undefined, 'bold')
      doc.text('Mecanico',65,422);
      let recy = 130
      doc.rect(42,684,80,recy,)
      if(recy >= 100){
          doc.addPage()
           y = 0 // Restart height position
      }
      doc.rect(42,40,80,156,)

         let z21 = 49 ;
        let y21 = 40
          doc.setFontSize(8)
      doc.setFont(undefined, 'bold')
      doc.text('Electrico',65,62);
      doc.text('Hidraulico',65,240);
      doc.text('Seguridad',65,430);
      doc.text('Llantas',65,715);
      doc.setFontSize(7.5)
    doc.setFont(undefined, 'normal')
       for(let i=5;i<11;i++){

            doc.rect(262,  y21 , 15, 26,)
           doc.rect(277, y21 , 15, 26,)
           doc.rect(292, y21 , 15, 26,)
           doc.rect(307, y21 , 15, 26,)

          doc.text( doc.splitTextToSize(item.electrico[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z21,'center')
          doc.rect(122, y21 , 140, 26,)
          doc.text( doc.splitTextToSize(item.electrico[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z21,'center')
          doc.rect(322, y21 , 150, 26,)
           doc.text(item.electrico[i].requisicion,480,z21)
          doc.rect(472, y21 , 80, 26,)
           item.electrico[i].estatusM=='B' ?  doc.text('X',267,y21+15,) : doc.text('',267,y21+15,)
          item.electrico[i].estatusM=='M' ?  doc.text('X',282,y21+15,) : doc.text('',267,y2+15,)
          item.electrico[i].estatusM=='R' ?  doc.text('X',297,y21+15,) : doc.text('',267,y2+15,) 
          item.electrico[i].estatusM=='N/a' ?  doc.text('X',297,y21+15,) : doc.text('',267,y2+15,) 
          z21+=26
          y21+=26
      } 
        let z3 = 204 ;
        let y3 = 196
       for(let i=0;i<item.hidraulico.length;i++){

             doc.rect(262,  y3 , 15, 26,)
           doc.rect(277, y3 , 15, 26,)
           doc.rect(292, y3 , 15, 26,)
           doc.rect(307, y3 , 15, 26,)
         
          doc.text( doc.splitTextToSize(item.hidraulico[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z3,'center')
          doc.rect(122, y3 , 140, 26,)
          doc.text( doc.splitTextToSize(item.hidraulico[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z3,'center')
          doc.rect(322, y3 , 150, 26,)
                doc.text(item.hidraulico[i].requisicion,480,z3)
          doc.rect(472, y3 , 80, 26,)
          item.hidraulico[i].estatusM=='B' ?  doc.text('X',267,y3+15,) : doc.text('',267,y3+15,)
          item.hidraulico[i].estatusM=='M' ?  doc.text('X',282,y3+15,) : doc.text('',267,y3+15,)
          item.hidraulico[i].estatusM=='R' ?  doc.text('X',297,y3+15,) : doc.text('',267,y3+15,) 
          item.hidraulico[i].estatusM=='N/a' ?  doc.text('X',297,y3+15,) : doc.text('',267,y3+15,)
          z3+=26
          y3+=26
      } 
      doc.rect(42,196,80,104,)
           
        let z4 = 308 ;
        let y4 = 300
       for(let i=0;i<item.seguridad.length;i++){

         doc.rect(262,  y4 , 15, 26,)
           doc.rect(277, y4 , 15, 26,)
           doc.rect(292, y4 , 15, 26,)
           doc.rect(307, y4 , 15, 26,)
         
          doc.text( doc.splitTextToSize(item.seguridad[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z4,'center')
          doc.rect(122, y4 , 140, 26,)
          doc.text( doc.splitTextToSize(item.seguridad[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z4,'center')
          doc.rect(322, y4 , 150, 26,)
                doc.text(item.seguridad[i].requisicion,480,z4)
          item.seguridad[i].estatusM=='B' ?  doc.text('X',267,y4+15,) : doc.text('',267,y4+15,)
          item.seguridad[i].estatusM=='M' ?  doc.text('X',282,y4+15,) : doc.text('',267,y4+15,)
          item.seguridad[i].estatusM=='R' ?  doc.text('X',297,y4+15,) : doc.text('',267,y4+15,) 
          item.seguridad[i].estatusM=='N/a' ?  doc.text('X',297,y4+15,) : doc.text('',267,y4+15,)
          doc.rect(472, y4 , 80, 26,)
          z4+=26
          y4+=26
      } 

      doc.rect(42,300,80,286,)

        let z5 = 594 ;
        let y5 = 586
       for(let i=0;i<item.llantas.length;i++){

         doc.rect(262,  y5 , 15, 26,)
         doc.rect(277, y5 , 15, 26,)
          doc.rect(292, y5 , 15, 26,)
          doc.rect(307, y5 , 15, 26,)
         
          doc.text( doc.splitTextToSize(item.llantas[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z5,'center')
          doc.rect(122, y5 , 140, 26,)
            doc.text( doc.splitTextToSize(item.llantas[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z5,'center')
          doc.rect(322, y5 , 150, 26,)
                doc.text(item.llantas[i].requisicion,480,z5)
          item.llantas[i].estatusM=='B' ?  doc.text('X',267,y5+15,) : doc.text('',267,y5+15,)
          item.llantas[i].estatusM=='M' ?  doc.text('X',282,y5+15,) : doc.text('',267,y5+15,)
          item.llantas[i].estatusM=='R' ?  doc.text('X',297,y5+15,) : doc.text('',267,y5+15,) 
          item.llantas[i].estatusM=='N/a' ?  doc.text('X',297,y5+15,) : doc.text('',267,y5+15,)
          doc.rect(472, y5 , 80, 26,)
          z5+=26
          y5+=26
      } 

      doc.rect(42,586,80,234,)

      doc.addPage()

       let z6 = 49 ;
        let y6 = 40

       for(let i=0;i<item.estetico.length;i++){
          doc.rect(262,  y6 , 15, 26,)
         doc.rect(277, y6 , 15, 26,)
          doc.rect(292, y6 , 15, 26,)
          doc.rect(307, y6 , 15, 26,)
         
          doc.text( doc.splitTextToSize(item.estetico[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z6,'center')
          doc.rect(122, y6 , 140, 26,)
          doc.text( doc.splitTextToSize(item.estetico[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z6,'center')
          doc.rect(322, y6 , 150, 26,)
                doc.text(item.estetico[i].requisicion,480,z6)
           item.estetico[i].estatusM=='B' ?  doc.text('X',267,y6+15,) : doc.text('',267,y6+15,)
          item.estetico[i].estatusM=='M' ?  doc.text('X',282,y6+15,) : doc.text('',267,y6+15,)
          item.estetico[i].estatusM=='R' ?  doc.text('X',297,y6+15,) : doc.text('',267,y6+15,) 
          item.estetico[i].estatusM=='N/a' ?  doc.text('X',297,y6+15,) : doc.text('',267,y6+15,)
          doc.rect(472, y6 , 80, 26,)
          z6+=26
          y6+=26
      } 
      doc.rect(42,40,80,130,)
      doc.setFontSize(8)
      doc.setFont(undefined, 'bold')
     doc.text('Estetico',65,110);
    doc.text('Estructura',65,300);

      doc.setFontSize(7.5)
    doc.setFont(undefined, 'normal')
       let z7 = 178 ;
        let y7 = 170

       for(let i=0;i<item.estructura.length;i++){
         
        doc.rect(262,  y7 , 15, 26,)
         doc.rect(277, y7 , 15, 26,)
          doc.rect(292, y7 , 15, 26,)
          doc.rect(307, y7 , 15, 26,)

          doc.text( doc.splitTextToSize(item.estructura[i].descripcion, (pdfInMM-lMargin-rMargin)),pageCenter,z7,'center')
          doc.rect(122, y7 , 140, 26,)
           doc.text( doc.splitTextToSize(item.estructura[i].observaciones, (pdfInMM-lMarginO-rMarginO)),pageCenterO,z7,'center')
          doc.rect(322, y7 , 150, 26,)
          doc.text(item.estructura[i].requisicion,480,z7)
             item.estructura[i].estatusM=='B' ?  doc.text('X',267,y7+15,) : doc.text('',267,y7+15,)
          item.estructura[i].estatusM=='M' ?  doc.text('X',282,y7+15,) : doc.text('',267,y7+15,)
          item.estructura[i].estatusM=='R' ?  doc.text('X',297,y7+15,) : doc.text('',267,y7+15,) 
          item.estructura[i].estatusM=='N/a' ?  doc.text('X',297,y7+15,) : doc.text('',267,y7+15,)
          doc.rect(472, y7 , 80, 26,)
          z7+=26
          y7+=26
      } 
      doc.rect(42,170,80,286,)
      doc.text('B: Bueno M: Malo R: Regular N/a: No Aplica',70,470)
      doc.rect(42,456,220,20,)
      doc.rect(262,456,60,20,)
      doc.rect(322,456,230,20,)
      
       doc.setFont(undefined, 'bold')
       doc.text('EL EQUIPO SE ENCUENTRA EN CONDICIONES \n DE OPERAR',150,490,'center');
      doc.rect(42,476,220,30,)
      doc.setFontSize(20)
       doc.setFont(undefined, 'normal')
       item.condiciones ? doc.text('X', 273,500) : doc.text('X',300,500)
       doc.setFontSize(7.5)
        doc.setFont(undefined, 'bold')
      doc.rect(262,476,30,30,)
      doc.text('SI',273,495)
      doc.rect(292,476,30,30,)
       doc.text('NO',300,495)
      
      doc.rect(322,476,230,30,)
      doc.rect(42,506,220,20,)
      doc.text('COMENTARIOS GENERALES','105','520')
      doc.rect(42,526,220,140,)
      doc.rect(262,506,60,40,)
      doc.text('MECANICO',273,525)

      doc.rect(322,506,230,30,)
      doc.rect(322,536,230,10,)
      doc.rect(322,546,230,30,)
      doc.rect(322,576,230,10,)

      doc.rect(262,546,60,40,)
      doc.text('OPERADOR',273,565)
      doc.rect(262,586,290,80,)
  doc.setFontSize(10)  
        var lMarginC=63; //left margin in mm
          var rMarginC=62; //right margin in mm
          var pdfInMMC=310;  // width of A4 in mm
          var pageCenterC=pdfInMMC/2;
       doc.text( doc.splitTextToSize(item.comentarios, (pdfInMMC-lMarginC-rMarginC)),pageCenterC,550,'center')

            doc.save("mantenimiento.pdf")
            
                    
        },

     
        limpiar(){
            this.arrendadora='',
            this.razonSocial=''
            this.nombreActivo='',
            this.tipoUnidad='',
            this.marca='',
            this.modelo='',
            this.anio='',
            this.capacidad='',
            this.numeroSerie='',
            this.placa='',
            this.estatu='',
            this.personQueEdita='',
            this.detalle='',
            this.personal='',
            this.propietario='',
            this.factura='',
            this.numeroEconomico='',
            this.claveMicrosip='',
            this.costo='',
            this.notas=''
            this.documentos=[],
            this.fotos=[],
            this.fechaAdquisicion='',
            this.foto='',
            this.ubicacion=''
            this.e6=1
            this.editedIndex = -1
            this.alert=false
        },

   
        
        
         mostrarNuevo(){
           // this.listarAgencia(this.$store.state.usuario.agencia)
          
            this.verNuevo =1;

          },
            ocultarNuevo(){
            this.verNuevo =0
            this.limpiar();
          },

          nextStep(){
            const a = [];
            const b = [];
            const c = [];
            const d = [];
            const e = [];
            const f = [];
            if(this.e1 == 1){
               if(this.activo2){
                 this.e1 = 2
               }else{
                 this.addErrorNotification()
               }
            }
            else if(this.e1 == 2){
              this.items.forEach((result)=>{
                a.push(result.estatusM)
            })
            console.log(a)
            a.includes('') ? this.addErrorNotification() : this.e1=3 
            }else if(this.e1==3){
              this.itemsElectrico.forEach((result)=>{
                b.push(result.estatusM)
              })
            b.includes('') ? this.addErrorNotification() : this.e1=4   
            }
            else if(this.e1==4){
              this.itemsHidraulico.forEach((result)=>{
                c.push(result.estatusM)
              })
            c.includes('') ? this.addErrorNotification() : this.e1=5   
            }else if(this.e1==5){
              this.itemsSeguridad.forEach((result)=>{
                d.push(result.estatusM)
              })
            d.includes('') ? this.addErrorNotification() : this.e1=6   
            }
            else if(this.e1==6){
              this.itemsLlantas.forEach((result)=>{
                e.push(result.estatusM)
              })
            e.includes('') ? this.addErrorNotification() : this.e1=7   
            }
              else if(this.e1==7){
              this.itemsEstetico.forEach((result)=>{
                f.push(result.estatusM)
              })
            f.includes('') ? this.addErrorNotification() : this.e1=8   
            }
          },

          listar(){
            let me = this;
                axios.get('/mantenimiento/list/').then(function (response){
                  me.mantenimientos = response.data
              }).catch(function(error){
                  console.log(error)
              })
        },

          listarActivpoPorNss(){
            let me = this
            axios.get('/activos/queryNss?numeroSerie='+this.activo2).then(function (response){
                me.activoPorQuery = response.data
                me.activo2 = response.data._id
                me.mostrarDetalleDeActivo = true
            }).catch(function(error){
                console.log(error)
            })
        },
        listarActivpoPorNumeroEconomico(){
            let me = this
            axios.get('/activos/queryNumeroEconomico?numeroEconomico='+this.numeroEconomicoBusqueda).then(function (response){
                me.activoPorQuery = response.data
                me.mostrarDetalleDeActivo = true
            }).catch(function(error){
                console.log(error)
            })
        },
        listarActivpoPorFactura(){
            let me = this
            axios.get('/activos/queryFactura?factura='+this.facturaBusqueda).then(function (response){
                me.activoPorQuery = response.data
                me.mostrarDetalleDeActivo = true
            }).catch(function(error){
                console.log(error)
            })
        },

            guardar(){
            let me = this
            if(this.editedIndex>-1){
               
                axios.put('/mantenimiento/update',
                {
                  '_id':this._id,
                  'mecanico':this.items,
                  'electrico':this.itemsElectrico,
                  'hidraulico':this.itemsHidraulico,
                  'seguridad':this.itemsSeguridad,
                  'estetico':this.itemsEstetico,
                  'estructura':this.itemsEstructura,
                  'llantas':this.itemsLlantas,
                  'activo':this.activo2,
                  'condiciones':this.condiciones,
                  'comentarios':this.comentarios
                })
                .then(function(){
                  
                    me.addSuccessNotification('Empresa actualizada')
                   
                })
                .catch(function(error){
                    console.log(error)
                })
            }else{
              
            axios.post('/mantenimiento/add',{
              'mecanico':this.items,
              'electrico':this.itemsElectrico,
              'hidraulico':this.itemsHidraulico,
              'seguridad':this.itemsSeguridad,
              'estetico':this.itemsEstetico,
              'estructura':this.itemsEstructura,
              'llantas':this.itemsLlantas,
              'activo':this.activo2,
              'condiciones':this.condiciones,
              'comentarios':this.comentarios
              })
            .then(function(){
               
                me.addSuccessNotification('Registro Exitoso')
            })
            .catch(function(error){
                console.log(error)
            })
            }
        },
        editItem(item){
            this._id = item._id;
            this.items = item.mecanico;
            this.itemsHidraulico = item.hidraulico;
            this.itemsElectrico = item.electrico;
            this.itemsSeguridad = item.seguridad;
            this.itemsEstetico = item.estetico;
            this.itemsEstructura = item.estructura;
            this.itemsLlantas = item.llantas;
            this.activo2 = item.activo.numeroSerie;
            this.listarActivpoPorNss()
            this.comentarios = item.comentarios;
            this.condiciones = item.condiciones;
            this.mostrarDetalleDeActivo = true
            this.editedIndex = 1;

           this.mostrarNuevo()
        },

        addSuccessNotification(mensaje) {
                this.$toast.success(mensaje, {
                position: 'top-right',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true
            });
        },
         addErrorNotification() {
                this.$toast.error("Error, verifique los campos ingresados", {
                position: 'bottom-right',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true
            });   
        },
        cerrarModalArrendadora(){
            this.dialogNuevaArrendadora =false;
            this.limpiar()
            this.editedIndex = -1
        },
     
    
        descargarFotos(adjuntos) {
      window.open(adjuntos, "_blank");
    },
     descargarDocumentos(documentos) {
      window.open(documentos, "_blank");
    },

    }
}
</script>
<style>
  .v-text-field input {
    font-size: .8em;
  }
</style>